var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.354 3.353a.5.5 0 0 1-.708 0L9 1.707V9.5a.5.5 0 0 1-1 0V1.707L6.354 3.353a.5.5 0 0 1-.708-.707L8.14.153c.2-.199.522-.199.722 0l2.493 2.493a.5.5 0 0 1 0 .707m-5 5.293a.5.5 0 0 0-.707 0L4 10.293V2.5a.5.5 0 1 0-1 0v7.793L1.354 8.646a.5.5 0 0 0-.708.707l2.493 2.493c.2.2.522.2.721 0l2.494-2.493a.5.5 0 0 0 0-.707",
    clipRule: "evenodd"
  })));
});
const SvgSwingsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSwingsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS4zNTM2IDMuMzUzMzJDMTEuMTU4MyAzLjU0ODU4IDEwLjg0MTcgMy41NDg1OCAxMC42NDY0IDMuMzUzMzJMOC45OTk2NiAxLjcwNjUzTDguOTk5NjYgOS40OTk3NkM4Ljk5OTY2IDkuNzc1OSA4Ljc3NTggOS45OTk3NiA4LjQ5OTY2IDkuOTk5NzZDOC4yMjM1MiA5Ljk5OTc2IDcuOTk5NjYgOS43NzU5IDcuOTk5NjYgOS40OTk3Nkw3Ljk5OTY2IDEuNzA3MTJMNi4zNTM1NCAzLjM1MzA5QzYuMTU4MjcgMy41NDgzNCA1Ljg0MTY4IDMuNTQ4MzMgNS42NDY0MyAzLjM1MzA2QzUuNDUxMTggMy4xNTc3OCA1LjQ1MTE5IDIuODQxMiA1LjY0NjQ2IDIuNjQ1OTVMOC4xMzkzOSAwLjE1MzI2NEM4LjMzODU2IC0wLjA0NTg4NjggOC42NjE0NiAtMC4wNDU4Nzg4IDguODYwNjMgMC4xNTMyODJMMTEuMzUzNiAyLjY0NjIxQzExLjU0ODggMi44NDE0NyAxMS41NDg4IDMuMTU4MDUgMTEuMzUzNiAzLjM1MzMyWk02LjM1MzYzIDguNjQ2MjJDNi4xNTgzOCA4LjQ1MDk0IDUuODQxOCA4LjQ1MDkyIDUuNjQ2NTIgOC42NDYxN0wzLjk5OTYzIDEwLjI5MjhMMy45OTk2MyAyLjQ5OTc0QzMuOTk5NjMgMi4yMjM2IDMuNzc1NzggMS45OTk3NCAzLjQ5OTYzIDEuOTk5NzRDMy4yMjM0OSAxLjk5OTc0IDIuOTk5NjMgMi4yMjM2IDIuOTk5NjMgMi40OTk3NEwyLjk5OTYzIDEwLjI5MjVMMS4zNTM2MyA4LjY0NjIyQzEuMTU4MzggOC40NTA5NCAwLjg0MTc5NyA4LjQ1MDkyIDAuNjQ2NTIgOC42NDYxN0MwLjQ1MTI0MyA4Ljg0MTQxIDAuNDUxMjE5IDkuMTU3OTkgMC42NDY0NjYgOS4zNTMyN0wzLjEzOTAxIDExLjg0NjJDMy4zMzgxNiAxMi4wNDU0IDMuNjYxMDggMTIuMDQ1NCAzLjg2MDI2IDExLjg0NjNMNi4zNTM1NyA5LjM1MzMzQzYuNTQ4ODUgOS4xNTgwOCA2LjU0ODg3IDguODQxNSA2LjM1MzYzIDguNjQ2MjJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";